import React, { ReactNode } from "react";
import cn from "classnames";
import styles from "./form-label.module.scss";

interface IFormLabelProps extends Omit<React.HTMLProps<any>, "title"> {
    className?: string;
    disabled?: boolean;
    titleClassName?: string;
    labelShort?: boolean;
    title?: ReactNode;
    ref?: React.Ref<any>;
    required?: boolean; // Add a required prop
}

export const FormLabel: React.FC<IFormLabelProps> = ({ children, className, titleClassName, title, required, disabled, labelShort }) => {
    return (
        <div className={cn(styles.wrapper, className)}>
            <div className={cn(styles.flex)}>
                {!title && titleClassName && <div className={titleClassName}></div>}
                {title && <div className={cn(styles.title, titleClassName, disabled ? styles.formLabelDisabled : undefined, labelShort ? styles.labelShort : undefined)} title={typeof title === "string" && labelShort ? title : undefined}>
                    {typeof title === "string" ? title.trim() : title}
                    {required && !labelShort && <span className={cn(styles.asterisk, disabled ? styles.formLabelDisabled : styles.formLabelRequired)}>*</span>}
                </div>}
                {required && labelShort && <span className={cn(styles.asterisk, disabled ? styles.formLabelDisabled : styles.formLabelRequired)}>*</span>}
            </div>
            {children}
        </div>
    );
};
